import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as setup from "../constants/setup";
import * as settings from "../constants/settings";
import * as handlers from "../constants/handlers";
import * as settingsActions from "../actions/settingsActions";
import * as translationHelper from "../helpers/translationHelper";

const summarySetup = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.SETUP_NEXT, actionTypes.SETUP_SET_STEP, actionTypes.SETUP_SKIP),
        switchMap(() => {
            if (state$.value.setup.active.name !== setup.SUMMARY) {
                return [];
            }

            return [
                settingsActions.getSingleSetRequest(
                    settings.LOCALE,
                    translationHelper.getRedlikeLocale(),
                    handlers.SETTINGS_SET_BASIC_SETUP_LOCALE
                )
            ];
        })
    );

export default [summarySetup];
